module.exports = __webpack_public_path__ + "static/media/9.5e415034.jpg";